<template>
<div class="tw-container tw-mx-auto tw-relative" v-show="!loading">
    <h3 class="tw-font-bold tw-text-4xl tw-px-4 md:tw-px-0 tw-text-white tw-font-sans tw-m-0">Playlists</h3>
    <section id="playlists" class="tw-items-center tw-pb-16 tw-mt-10" v-if="Object.keys(playlists).length">
            <div v-if="loading" class="tw-flex tw-justify-center tw-items-center tw-w-full">
                <v-progress-circular indeterminate color="#5A3273"></v-progress-circular>
            </div>
            <div class="md:tw-container md:tw-mx-auto tw-relative tw-overflow-visible" v-show="!loading" :id="'playlist_'+index" v-for="(playlist, index) in videos" :key="index">
                <div class="tw-flex tw-w-full tw-items-center tw-px-4 md:tw-px-0">
                    <v-list-item-title class="tw-text-white tw-font-sans tw-font-semibold">{{playlist.name}}</v-list-item-title>
                    <v-btn dark  small :elevation="0" link class="tw-ml-4" target="_blank" :href="'https://www.youtube.com/playlist?list='+playlist.id"><v-icon left>mdi-eye</v-icon>Playlist</v-btn>
                </div> 
                <div class="tw-flex tw-items-center tw-justify-center tw-relative tw-flex-wrap tw-mb-12" >
                    <div class="tw-items-center tw-justify-between tw-absolute tw-w-full slide_btn tw-overflow-visible tw-hidden lg:tw-flex">
                        <div :class="'slide_left_'+index" class="btn_slide left tw-text-white tw-z-20 tw-h-full tw-relative tw-flex tw-items-center tw-justify-center">
                            <i class="mdi mdi-chevron-left tw-text-white  tw-ml-5 tw-text-6xl tw-relative"></i>
                        </div>
                        <div :class="'slide_right_'+index" class="btn_slide right tw-text-white tw-z-20 tw-h-full tw-relative tw-flex tw-items-center tw-justify-center">
                            <i class="mdi mdi-chevron-right tw-text-white tw-mr-5 tw-text-6xl tw-relative"></i>
                        </div>
                    </div>
                    <div class="swiper-container tw-w-full tw-mt-5">
                        <!-- Additional required wrapper -->
                        <div class="swiper-wrapper">
                            <!-- Slides -->
                            <div class="swiper-slide" v-for="video in playlist.items" :key="video.id">
                                <v-img :src="video.snippet.thumbnails.high.url" class="tw-shadow-lg tw-rounded-md tw-border tw-border-gray-900" min-height="150" max-height="300" :aspect-ratio="16/9">
                                    <a :href="`https://www.youtube.com/watch?v=${video.snippet.resourceId.videoId}&list=${playlist.id}`" target="_blank" class="tw-w-full tw-h-full tw-absolute tw-flex-wrap tw-items-center tw-justify-center tw-text-center tw-flex single-slider tw-transition-all tw-duration-300  hover:tw-bg-opacity-0 tw-bg-opacity-60 tw-bg-black">
                                        <div class="tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0 tw-flex-wrap tw-items-center tw-justify-center tw-text-center tw-flex single-slider">
                                            <v-btn class="ma-2" outlined large fab color="white">
                                                <v-icon>fas fa-play</v-icon>
                                            </v-btn>
                                        </div>
                                    </a>
                                </v-img>
                                <div class="tw-block tw-mt-3 tw-truncate tw-w-full">
                                    <v-list-item-subtitle class="tw-font-sans tw-text-white tw-p-0 tw-truncate tw-m-0 tw-text-base">{{video.snippet.title}}</v-list-item-subtitle>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </section>
</div>
</template>

<script>
import Swiper from 'swiper';
export default {
    props: ['playlists'],
    data(){
      return{
        loading: true,
        videos: [],
        playlist_loaded: false
      }
    },
    methods:{
      async getVideos(){
            this.videos = [];
            const vm = this;
            let promises = [];
            let youtube_ids = [];
            async function getPlaylists(){
                for(const playlist of vm.playlists){
                    youtube_ids.push(playlist.youtube_id);
                }
                await axios.get('/api/youtube-playlist/load', {
                    params: {
                        'youtube_ids': youtube_ids,
                    }
                }).then(function(res) {
                        res.data.data.items.forEach(data => {
                            vm.videos.push({
                                name: data.snippet.title,
                                id: data.id,
                                items: [],
                            });
                        });
                    },
                    function(err){ 
                        vm.loading = false;
                    }
                );
            }
            async function listItems(){
                for(const [i, playlist] of vm.playlists.entries()){
                    await axios.get('/api/youtube-playlist/load-items', {
                        params: {
                            "playlist_id": playlist.youtube_id
                        }
                    }).then(function(res){
                        res.data.data.items.forEach(video => {
                            if(video.status.privacyStatus == 'public'){
                                vm.videos[i].items.push(video);
                            }
                        });
                        vm.loading = false;
                    },
                        function(err) {
                            vm.loading = false;
                        }
                    );
                }
            }
             getPlaylists().then(() => {
                listItems().then(e => {
                    if(Object.keys(this.videos).length){
                        let swiper = []
                        this.videos.forEach(function(playlist, index){ 
                            swiper[index] = new Swiper(`#playlist_${index} .swiper-container`, {
                                slidesPerView: 1.5,
                                slidesPerGroup: 1,
                                spaceBetween: 20,
                                slidesOffsetBefore: 15,
                                slidesOffsetAfter: 15,
                                observer: true,
                                observeParents: true,
                                observeSlideChildren:true,
                                navigation: {
                                    nextEl: `.slide_right_${index}`,
                                    prevEl: `.slide_left_${index}`,
                                },
                                breakpoints: {
                                    768: {
                                        slidesPerView: 2,
                                        slidesPerGroup: 1,
                                        slidesOffsetBefore: 0,
                                        slidesOffsetAfter: 0,
                                    },
                                    1024: {
                                        slidesPerView: 3,
                                        slidesPerGroup: 1,
                                        slidesOffsetBefore: 0,
                                        slidesOffsetAfter: 0,
                                    },
                                    1280: {
                                        slidesPerView: 4,
                                        slidesPerGroup: 1,
                                        slidesOffsetBefore: 0,
                                        slidesOffsetAfter: 0,
                                    },
                                },
                            });
                        });
                    }
                });
            })
        },
    },
    mounted(){
        this.getVideos();
    },
}
</script>

<style lang="scss">
    .cover_img::before{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
    }
</style>
<style scoped>
.slide_btn{
    height: 100%;
    top: 0px; 
}
.btn_slide.slide_,.btn_slide.left{
    border: none!important;
    margin-left: 0!important;
}
.btn_slide.swiper-button-disabled{
    opacity: 0!important;
    pointer-events: none;
}
.btn_slide.right::before{
    width: 274px;
    background: rgb(29 4 25);
    background: -moz-linear-gradient(90deg, rgba(47,7,41,0) 0%, rgb(31, 31, 31) 100%);
    background: -webkit-linear-gradient(90deg, rgba(47,7,41,0) 0%, rgb(31, 31, 31) 100%);
    background: linear-gradient(90deg, rgb(29 4 25 / 0%) 0%, rgb(31, 31, 31) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#2f0729",endColorstr="#2f0729",GradientType=1);
    height:100%;
    transition: all 0.3s ease-in-out;
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
}
.btn_slide.left::before{
    width: 274px;
    background: rgb(29 4 25);
    background: -moz-linear-gradient(270deg, rgba(47,7,41,0) 0%, rgb(31, 31, 31) 100%);
    background: -webkit-linear-gradient(270deg, rgba(47,7,41,0) 0%, rgb(31, 31, 31) 100%);
    background: linear-gradient(270deg, rgb(29 4 25 / 0%) 0%, rgb(31, 31, 31) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#2f0729",endColorstr="#2f0729",GradientType=1);
    height:100%;
    transition: all 0.3s ease-in-out;
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
}
.bg_card{
  background:#202020!important;
}
h1 {
  color: #d6d6d6;
}

h2, h3 {
  color: #696969;
}

.bg-cover {
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
  bottom: 0;
  right: 0;
  background-position: 30% 45%;
  background-size: cover;
  z-index: 0;
}

</style>